<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from '../wrappers/BaseModal.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../../store/useUserStore'
const props = defineProps<{
  modelValue: boolean
}>()
const emit = defineEmits<{
  (e: 'continueToLegal', overrideRule: boolean): void
  (e: 'update:modelValue'): void
}>()
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
const applyTravelOverrideRule = ref(false)

const user = storeToRefs(useUserStore())

const labelKey = computed(() => {
  switch (user.country_id.value) {
    case 2: //can
      return 'travelOverrideCan'
    case 1: //us + others
    default:
      return 'travelOverride'
  }
})

const emitContinue = () => emit('continueToLegal', applyTravelOverrideRule.value)
</script>
<template>
  <BaseModal v-model="value">
    <template #title> {{ label('endOfDay') }} </template>
    <template #content>
      {{ label('endOfDayInfo') }}
      <div>
        <q-checkbox v-model="applyTravelOverrideRule" :label="label(labelKey)" />
      </div>
    </template>
    <template #actions>
      <q-btn rounded flat :label="label('close')" v-close-popup />
      <q-btn rounded color="primary" v-close-popup @click="emitContinue">
        <span class="q-px-sm">{{ label('continue') }}</span>
      </q-btn>
    </template>
  </BaseModal>
</template>
